<template>
  <div :style="{'height': `${calcHeight}px`,'width': `${calcWidth}px`}">
    <div class="explain">
      <div class="item">
        <div class="square" style="background: #2C3E50"></div>
        <div class="text">公司</div>
      </div>
      <div class="item">
        <div class="square" style="background: #27AE60;"></div>
        <div class="text">位置</div>
      </div>
      <div class="item">
        <el-switch v-model="gw" active-color="#E74C3C" @change="disableItem(3)">
        </el-switch>
<!--        <div class="square" style="background: #E74C3C;cursor: pointer"></div>-->
        <div class="text ml-5">岗位</div>
      </div>
      <div class="item">
        <el-switch :disabled="!gw" v-model="ry" active-color="#3498DB" @change="disableItem(3)">
        </el-switch>
        <div class="text ml-5">人员</div>
      </div>
    </div>
    <div class="dime" id="container1" :style="{'height': `${calcHeight}px`,'width': `${calcWidth}px`}">
    </div>
  </div>
</template>

<script>
import url from '@/config/url'
import { ExtensionCategory, Graph, Rect, register, treeToGraphData } from '@antv/g6'
const statusColors = [
  '#2C3E50',
  '#27AE60',
  '#E74C3C',
  '#3498DB'
]

const DEFAULT_LEVEL = 'overview'

/**
 * Draw a chart node with different ui based on the zoom level.
 */
class ChartNode extends Rect {
  get data () {
    return this.context.model.getElementDataById(this.id)
  }

  get level () {
    return DEFAULT_LEVEL // this.data.level || DEFAULT_LEVEL;
  }

  getLabelStyle () {
    const text = this.data.label
    const labelStyle =
      this.level === 'overview'
        ? {
            text,
            fill: '#FFF',
            fontSize: 12,
            textAlign: 'center',
            transform: this.data.other === '1' || this.data.other === '2' ? [['translate', 0, 0]] : [['translate', 0, 0], ['rotate', 90]]
          }
        : {
            fill: '#2078B4',
            fontSize: 14,
            fontWeight: 400,
            textAlign: 'left',
            transform: [['translate', -65, -15]]
          }
    return { ...labelStyle }
  }

  getKeyStyle (attributes) {
    return {
      ...super.getKeyStyle(attributes),
      fill: statusColors[Number(this.data.other) - 1]
    }
  }

  render (attributes = this.parsedAttributes, container = this) {
    super.render(attributes, container)

    // this.drawPositionShape(attributes, container);

    // this.drawStatusShape(attributes, container);

    // this.drawPhoneShape(attributes, container);
  }
}

register(ExtensionCategory.NODE, 'chart-node', ChartNode)
export default {

  data () {
    return {
      gw: false,
      ry: false,
      graph: null,
      calcHeight: 600,
      calcWidth: window.innerWidth - 330,
      originalData: null,
      currentData: null
    }
  },
  created () {
    this.calcHeight = window.innerHeight - 430
    this.checkG6AndInit()
  },
  methods: {
    disableItem (index) {
      if (!this.gw) {
        this.ry = false
      }
      this.initData()
    },
    async downloadImage () {
      const dataURL = await this.graph.toDataURL()
      const [head, content] = dataURL.split(',')
      console.log(head)
      // const contentType = head.match(/:(.*?);/)![1]

      const bstr = atob(content)
      let length = bstr.length
      const u8arr = new Uint8Array(length)

      while (length--) {
        u8arr[length] = bstr.charCodeAt(length)
      }

      const blob = new Blob([u8arr])

      const url = URL.createObjectURL(blob)
      const a = document.createElement('a')
      a.href = url
      a.download = 'graph.png'
      a.click()
    },
    checkG6AndInit () {
      this.initData()
    },
    initData () {
      // 销毁旧实例
      if (this.graph) {
        this.graph.destroy()
      }
      if (!this.originalData) {

        this.$http.get(url.getOwhUserOrgTree).then(res => {
          // console.log(res);
          if (res.data.code === 200) {
            this.originalData = res.data.data
            this.prepareData()
          }
        })
      } else {
        this.prepareData()
      }
    },
    prepareData () {
      console.log('prepareData')
      const data = JSON.parse(JSON.stringify(this.originalData))
      this.dealData(data.children)
      console.log(data)

      this.calcHeight = 600
      this.calcWidth = window.innerWidth - 330
      this.initGraph(data)
    },
    dealData (data) {
      for (let i = 0; i < data.length; i++) {
        const cdata = data[i]
        if (cdata.other === '2' && !this.gw) {
          if (cdata.children) {
            const children = []
            for (let j = 0; j < cdata.children.length; j++) {
              if (cdata.children[j].other === '2') {
                children.push(cdata.children[j])
              }
            }
            cdata.children = children.length > 0 ? children : null
          }
        }
        if (cdata.other === '3' && !this.ry) {
          cdata.children = null
        }
        if (cdata.children) {
          this.dealData(cdata.children)
        }
      }
    },
    isLeafNode (d) {
      return !d.children || d.children.length === 0
    },
    initGraph (data) {
      const cdata = treeToGraphData(data)
      cdata.nodes.forEach(node => {
        node.id = node.id.toString()
      })
      const maxLen = cdata.nodes.filter(node => !node.children || node.children.length === 0).length
      const level = cdata.nodes.reduce((max, node) => node.level > max ? node.level : max, -Infinity)
      this.calcHeight = Math.max(this.calcHeight, level * 160)
      this.calcWidth = Math.max(this.calcWidth, maxLen * (this.gw ? (this.ry ? 65 : 80) : 110))
      cdata.edges.forEach(edge => {
        edge.source = edge.source.toString()
        edge.target = edge.target.toString()
      })
      this.graph = new Graph({
        container: 'container1',
        data: {
          nodes: cdata.nodes,
          edges: cdata.edges
        },
        node: {
          type: 'chart-node',
          style: {
            labelPlacement: 'center',
            collapsed: true,
            lineWidth: 1,
            ports: [{ placement: 'top' }, { placement: 'bottom' }],
            radius: 2,
            // shadowBlur: 10,
            // shadowColor: '#e0e0e0',
            // shadowOffsetX: 3,
            size: (data) => data.other === '1' || data.other === '2' ? [130, 30] : [30, 130],
            stroke: (data) => statusColors[Number(data.other) - 1]
          }
        },
        edge: {
          type: 'polyline',
          style: {
            router: {
              type: 'orth'
            },
            stroke: '#C0C0C0'
          }
        },
        layout: {
          type: 'dagre',
          nodesep: 10
        },
        autoFit: 'view',
        behaviors: []//'zoom-canvas', 'drag-canvas'
      })

      // this.graph.data(data);
      this.graph.render()
    }
  }
}
</script>

<style lang="scss" scoped>
.explain {
  position: absolute;
  width: 85px;
  height: 100px;
  gap: 5px;
  z-index: 99999;
  top: 0;
  left: 0;
  margin-bottom: 10px;
  font-size: 14px;
  display: flex;
  justify-content: flex-end;
  flex-direction: column;
  .item {
    display: flex;
    align-items: center;
    margin-left: 10px;
    .square {
      width: 40px;
      height: 15px;
      margin-right: 3px;
    }
    .icon {
      width: 15px;
      height: 15px;
      margin-right: 3px;
    }
    .text {
      color: #999;
    }
    .ml-5{
      margin-left: 4px;
    }
  }
}
</style>
